module.exports = __webpack_public_path__ + "static/media/allergens_unselected.29ab95cf.svg";